import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { ScrollArea } from "../ui/scroll-area";
import { FileText, Printer, ShieldCheck } from "lucide-react";
import { formatCurrency } from "../../lib/utils";
import { DOC_TYPE_LABELS } from "../../lib/fiscal";

const StatusBadge = ({ doc }) => {
  if (doc.status === "A" || doc.status === "cancelled") return <Badge className="bg-red-500/20 text-red-500">Anulado</Badge>;
  if (doc.training) return <Badge className="bg-amber-500/20 text-amber-600">Formação</Badge>;
  if (doc.source_billing === "M") return <Badge className="bg-blue-500/20 text-blue-500">Manual recuperado</Badge>;
  if (!doc.hash) return <Badge variant="outline">Sem assinatura (legado)</Badge>;
  return <Badge className="bg-emerald-500/20 text-emerald-600"><ShieldCheck className="w-3 h-3 mr-1" />Assinado</Badge>;
};

export const FiscalDocumentsList = ({ docs, onPrint, onVerify }) => (
  <ScrollArea className="h-[420px]">
    <div className="space-y-2">
      {docs.map((doc) => (
        <div key={doc.invoice_id} className="flex flex-wrap items-center justify-between gap-3 p-3 rounded-lg border hover:bg-muted/50 transition-colors" data-testid={`fiscal-doc-${doc.invoice_id}`}>
          <div className="flex items-center gap-3 min-w-0">
            <div className="p-2 rounded bg-primary/10"><FileText className="w-4 h-4 text-primary" /></div>
            <div className="min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-mono font-semibold">{doc.invoice_number}</span>
                <Badge variant="outline" className="text-xs">{DOC_TYPE_LABELS[doc.doc_type || doc.invoice_type] || doc.invoice_type}</Badge>
                <StatusBadge doc={doc} />
              </div>
              <div className="flex items-center gap-3 text-xs text-muted-foreground flex-wrap">
                <span>{doc.customer_name || "Consumidor final"} · NIF {doc.customer_nif || "999999999"}</span>
                <span>{doc.invoice_date || (doc.created_at || "").slice(0, 10)}</span>
                {doc.hash_print && <span className="font-mono">{doc.hash_print}</span>}
                {doc.related_invoice_number && <span>Rectifica {doc.related_invoice_number}</span>}
              </div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="text-right">
              <p className="font-bold font-mono">{formatCurrency(doc.total)}</p>
              <p className="text-xs text-muted-foreground">IVA {formatCurrency(doc.tax)}</p>
            </div>
            {doc.hash && <Button size="sm" variant="ghost" onClick={() => onVerify(doc)} data-testid={`fiscal-verify-${doc.invoice_id}`}>Verificar</Button>}
            <Button size="sm" variant="outline" onClick={() => onPrint(doc)} className="gap-1" data-testid={`fiscal-print-${doc.invoice_id}`}><Printer className="w-3 h-3" /> {doc.print_count ? `${doc.print_count + 1}.ª via` : "Imprimir"}</Button>
          </div>
        </div>
      ))}
      {docs.length === 0 && (
        <div className="flex flex-col items-center justify-center py-12 text-muted-foreground">
          <FileText className="w-12 h-12 mb-4 opacity-50" />
          <p>Nenhum documento no período</p>
        </div>
      )}
    </div>
  </ScrollArea>
);
